import { render } from "./DocumentStatusEditInPlace.vue?vue&type=template&id=6247c14a&scoped=true"
import script from "./DocumentStatusEditInPlace.vue?vue&type=script&lang=js"
export * from "./DocumentStatusEditInPlace.vue?vue&type=script&lang=js"

import "./DocumentStatusEditInPlace.vue?vue&type=style&index=0&id=6247c14a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6247c14a"]])

export default __exports__